/** Extrai o primeiro nome: "João Silva" → "João" */
export const getFirstName = (name: string | null | undefined): string =>
  name?.trim().split(' ')[0] ?? '';

/** Capitaliza a primeira letra: "hello" → "Hello" */
export const capitalize = (value: string | null | undefined): string => {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

/** Extrai iniciais do nome: "João Silva" → "JS" */
export const getInitials = (name: string | null | undefined): string => {
  if (!name?.trim()) return '';
  const parts = name.toUpperCase().normalize('NFD').trim().split(' ');
  const last = parts.at(-1);
  if (!last) return parts[0][0];
  return `${parts[0][0]}${last[0]}`;
};

/**
 * Abrevia nome completo: "João Silva" → "João S."
 * Retorna "Usuário W." se o nome for vazio/nulo.
 */
export const shortenName = (name: string | null | undefined): string => {
  const trimmed = name?.trim();
  if (!trimmed) return 'Usuário W.';

  const parts = trimmed.split(' ');
  if (parts.length === 1) return capitalize(trimmed);
  const lastInitial = parts.at(-1)?.[0]?.toUpperCase() ?? '';
  return `${capitalize(parts[0])} ${lastInitial}.`;
};
